import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

import { DataAccessPcvizService } from '@mirage-projects/cw-pcviz-core';

export interface ExportPointFormat {
    label: string;
    value: string;
    formatAllowsUnitTransform?: boolean;
}
/**
 * This component displays the select that allows you to choose the export format.
 * Depending on the exportFilter input, one format or another will be displayed.
 */
@Component({
    selector: 'cw-export-format',
    templateUrl: './export-format.component.html',
    standalone: false,
})
export class ExportFormatComponent implements OnInit {
    /**
     * Filter to get the formats to be displayed
     */
    @Input() exportFilter!: string[];

    /**
     * Will be emitted every time the format is changed.
     */
    @Output() changeFormat: EventEmitter<ExportPointFormat> = new EventEmitter();

    formatValue!: ExportPointFormat;
    formatList!: ExportPointFormat[];

    constructor(private dataAccessPcvizService: DataAccessPcvizService) {}

    ngOnInit(): void {
        const exportService = this.dataAccessPcvizService.getExporterRegistryInstance();
        this.formatList = exportService.getFormatInfo(this.exportFilter);
        this.formatValue = this.formatList[0];
        this.onChange();
    }

    onChange(): void {
        this.changeFormat.emit(this.formatValue);
    }
}
